import React from "react";
import Slider from "react-slick";
import { FaQuoteLeft } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function TestimonialsSection() {
  const testimonials = [
    {
      text: "Switching to SynergySoft completely transformed my website performance. Fast, reliable, and worth every penny!",
      author: "✨ Rich Joye",
    },
    {
      text: "Inka customer support itna tez aur helpful hai ke main har kisi ko recommend karta hoon. Bilkul best experience!",
      author: "🌟 Adeel Khan",
    },
    {
      text: "Their uptime is perfect — I haven’t seen my site down even once in six months.",
      author: "🔥 Sarah Peterson",
    },
    {
      text: "Website ki speed itni improve hui ke mere clients bhi notice kar rahe hain. Shukriya SynergySoft!",
      author: "💫 Maryam Ali",
    },
    {
      text: "I’ve used many hosting companies, but SynergySoft’s performance and transparency are unmatched.",
      author: "🚀 James Robert",
    },
    {
      text: "Mujhe pehle lagta tha ke reliable hosting mehngi hoti hai, lekin SynergySoft ne sab kuch badal diya.",
      author: "🌙 Imran Shaikh",
    },
    {
      text: "The control panel is super intuitive. Even non-tech users can manage their websites easily.",
      author: "💡 Anna Williams",
    },
    {
      text: "Main 24/7 support ko call karta hoon aur hamesha friendly aur instant response milta hai. Bohat zabardast!",
      author: "🌻 Hira Faisal",
    },
    {
      text: "I migrated three of my client sites to SynergySoft — smooth transition and noticeable speed boost!",
      author: "⚡ Michael Chen",
    },
    {
      text: "Inka hosting setup professional aur secure hai. Mujhe apni website ke liye bilkul sukoon mil gaya.",
      author: "🌼 Umer Farooq",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5500,
    arrows: false,
    pauseOnHover: true,
  };

  return (
    <section className="relative bg-gradient-to-br from-blue-900 via-indigo-800 to-blue-600 py-16 md:py-24 overflow-hidden">
      {/* Soft glow effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_30%,_rgba(255,255,255,0.1),_transparent_60%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,_rgba(0,200,255,0.12),_transparent_60%)]"></div>

      <div className="container mx-auto px-6 relative z-10">
        {/* Title */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-extrabold text-white drop-shadow-lg tracking-tight">
            What Our Clients Say
          </h2>
          <p className="text-blue-200 mt-3 text-lg md:text-xl italic">
            Real experiences. Genuine satisfaction.
          </p>
          <div className="w-20 h-1 bg-blue-400 mx-auto mt-5 rounded-full shadow-lg"></div>
        </div>

        {/* Testimonial Slider */}
        <div className="max-w-3xl mx-auto bg-white/10 backdrop-blur-lg border border-white/20 rounded-3xl shadow-2xl p-10 transition-all duration-500 hover:shadow-blue-500/30">
          <Slider {...settings}>
            {testimonials.map((item, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center space-y-6"
              >
                <FaQuoteLeft className="text-blue-300 text-4xl mb-2 drop-shadow-lg animate-pulse" />
                <p className="text-blue-50 text-lg md:text-xl leading-relaxed italic font-light max-w-2xl">
                  “{item.text}”
                </p>
                <div className="mt-2 font-semibold text-blue-100 text-lg">
                  {item.author}
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      {/* Bottom glow */}
      <div className="absolute bottom-0 left-0 w-full h-20 bg-gradient-to-t from-blue-400/20 to-transparent blur-2xl"></div>
    </section>
  );
}
